/**
 * ErrorBlock 组件提供通用的错误状态展示
 * @module ErrorBlock
 * @param {String} text 提示文案
 * @param {String} btnText 按钮文案
 * @param {Boolean} cancelPosition 是否取消组件默认绝对定位
 *
 * @param {String} className 容器自定义类名
 *
 * @param {Function} onClick 按钮点击事件
 */

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from '@/utils/common';

import styles from './index.module.less';

const DEFAULT_TEXT = 'The server is down';
const DEFAULT_OFFLINE_TEXT = 'Your current network signal is not very good';

const ErrorBlock = ({ text, btnText, cancelPosition, className, onClick }) => {
  const formatText = text || (navigator.onLine ? DEFAULT_TEXT : DEFAULT_OFFLINE_TEXT);

  const classes = classNames(styles.errorBlock, {
    [styles.position]: !cancelPosition
  }, className);

  return (
    <div className={ classes }>
      <img className={ styles.errorBlock__image } src={ require('@/images/error.png') } />
      <p className={ styles.errorBlock__tips }>{ formatText }</p>
      <button className={ styles.errorBlock__btn } onClick={ onClick }>{ btnText }</button>
    </div>
  );
};

ErrorBlock.propTypes = {
  text: PropTypes.string,
  btnText: PropTypes.string,
  cancelPosition: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func
};

ErrorBlock.defaultProps = {
  text: '',
  btnText: 'Click to refresh',
  cancelPosition: false,
  onClick: noop
};

export default ErrorBlock;
